import React, { useState } from "react";
import { pullOutProducts } from "./data/rollingShuttersData";
import "../../App.css";
import { Helmet } from "react-helmet";
import banner from "../../assets/rolling-sutter-banner.webp";

const PullOut = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [mainImage, setMainImage] = useState("");
  const [activeFAQ, setActiveFAQ] = useState(null);
  const [activeTab, setActiveTab] = useState("desc");
const [previewImage, setPreviewImage] = useState(null);
  // YouTube helpers
  const getEmbedUrl = (url) => {
    if (!url) return "";

    if (url.includes("shorts")) {
      const id = url.split("/shorts/")[1]?.split("?")[0];
      return `https://www.youtube.com/embed/${id}`;
    }

    if (url.includes("watch?v=")) {
      const id = url.split("v=")[1]?.split("&")[0];
      return `https://www.youtube.com/embed/${id}`;
    }

    return url;
  };

  const getWatchUrl = (url) => {
    if (!url) return "";
    if (url.includes("shorts")) {
      const id = url.split("/shorts/")[1]?.split("?")[0];
      return `https://www.youtube.com/watch?v=${id}`;
    }
    return url;
  };

  const filteredProducts = pullOutProducts.filter(
    (product) => product.category === "rolling shutter"
  );

  if (!filteredProducts.length)
    return <p style={{ textAlign: "center" }}>No products found.</p>;

  return (
    <div className="product-container">

      <Helmet>
        <link
    rel="canonical"
    href="https://slimlinehardwarefittings.com/rolling-shutter"
  />
        <title>Kitchen Rolling Shutter | Cabinet System</title>
      </Helmet>

      {/* BANNER */}
      <div className="hinge-banners">
        <img src={banner}   rel="preload" alt="Rolling Shutter Banner" />
        <h2 className="banner-text">Products</h2>
      </div>

      <h2 className="page-title">ROLLING SHUTTER</h2>

      {!selectedProduct ? (

        <div className="product-grid">
          {filteredProducts.map((item) => (
            <div
              className="product-card"
              key={item.code}
              onClick={() => {
                setSelectedProduct(item);
                setMainImage(item.mainImage);
                setActiveFAQ(null);
                setActiveTab("desc");
              }}
            >
             <img
  src={item.mainImage}
  alt={item.name}
  loading="lazy"
  onClick={(e) => {
    e.stopPropagation();
    setPreviewImage(item.mainImage);
  }}
  style={{ cursor: "zoom-in" }}
/>
              <h4>{item.name}</h4>
            </div>
          ))}
        </div>

      ) : (
        <>
          {/* BACK */}
          <button
            className="back-btn"
            onClick={() => {
              setSelectedProduct(null);
              setMainImage("");
              setActiveFAQ(null);
              setActiveTab("desc");
            }}
          >
            ← Back
          </button>

          <div className="hinge-details">

            {/* LEFT */}
            <div className="left-box">

              <div className="hinge-image">
               <img
    src={mainImage}
    alt={selectedProduct?.name}
    className="zoomable-image"
    onClick={() => setPreviewImage(mainImage)}
  />
              </div>

              {/* THUMBNAILS */}
              {selectedProduct.thumbnails?.length > 0 && (
                <div className="hinge-thumbnails">
                  {selectedProduct.thumbnails.map((img, i) => (
                    <img
  key={i}
  src={img}
  alt=""
  loading="lazy"
  onClick={() => setMainImage(img)}
  onDoubleClick={() => setPreviewImage(img)}
/>
                  ))}
                </div>
              )}

              {/* VIDEO */}
              {selectedProduct.video && (
                <>
                  <div className="product-video">
                    <iframe
                      width="100%"
                      height="300"
                      src={getEmbedUrl(selectedProduct.video)}
                      title="Product Video"
                      frameBorder="0"
                      allowFullScreen
                    ></iframe>
                  </div>

                  {/* <a
                    href={getWatchUrl(selectedProduct.video)}
                    target="_blank"
                    rel="noreferrer"
                    className="video-btn"
                  >
                    ▶ Watch Video
                  </a> */}
                </>
              )}

            </div>

            {/* RIGHT */}
            <div className="hinge-info">

              <h2>{selectedProduct.name}</h2>

              {/* PRICE */}
              {(selectedProduct.price || selectedProduct.oldPrice) && (
                <div className="price-box">
                  <span className="price">{selectedProduct.price}</span>
                  <span className="old-price">{selectedProduct.oldPrice}</span>
                </div>
              )}

              {/* META */}
              {(selectedProduct.sku || selectedProduct.stock) && (
                <div className="product-meta">
                  {selectedProduct.sku && (
                    <p><strong>SKU:</strong> {selectedProduct.sku}</p>
                  )}
                  {selectedProduct.stock && (
                    <p><strong>Status:</strong> {selectedProduct.stock}</p>
                  )}
                </div>
              )}

              {/* BUTTONS */}
              <div className="btns">

                {selectedProduct.catalogue && (
                  <a href={selectedProduct.catalogue} download>
                    📥 Download Catalogue
                  </a>
                )}

                {selectedProduct.inquiry && (
                  <a href={selectedProduct.inquiry} target="_blank" rel="noreferrer">
                    💬 Inquiry
                  </a>
                )}

                {selectedProduct.video && (
                  <a
                    href={getWatchUrl(selectedProduct.video)}
                    target="_blank"
                    rel="noreferrer"
                  >
                    ▶ Watch Video
                  </a>
                )}

              </div>

              {/* TABS */}
              <div className="tabs">
                <button
                  className={activeTab === "desc" ? "active" : ""}
                  onClick={() => setActiveTab("desc")}
                >
                  Description
                </button>

                <button
                  className={activeTab === "info" ? "active" : ""}
                  onClick={() => setActiveTab("info")}
                >
                  Additional Info
                </button>
              </div>

              {/* DESCRIPTION */}
              {activeTab === "desc" && (
                <>
                  <p>{selectedProduct.short}</p>

                  <ul>
                    {selectedProduct.features?.map((f, i) => (
                      <li key={i}>{f}</li>
                    ))}
                  </ul>
                </>
              )}

              {/* ✅ FIXED ADDITIONAL INFO (TABLE STYLE) */}
              {activeTab === "info" && (
                <div className="info-table">
                  {Array.isArray(selectedProduct?.specifications) &&
                  selectedProduct.specifications.length > 0 ? (
                    <table>
                      <tbody>
                        {selectedProduct.specifications.map((s, i) => (
                          <tr key={i}>
                            <td><b>{s.label}</b></td>
                            <td>{s.value}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <p>No additional info</p>
                  )}
                </div>
              )}

            </div>

          </div>

          {/* SPEC TABLE */}
          {selectedProduct.specTable?.length > 0 && (
            <div className="spec-section">
              <h2>Specifications</h2>

              <table className="spec-table">
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>Code</th>
                    <th>Size</th>
                    <th>Finish</th>
                  </tr>
                </thead>

                <tbody>
                  {selectedProduct.specTable.map((item, i) => (
                    <tr key={i}>
                      <td>{item.item}</td>
                      <td>{item.code}</td>
                      <td>{item.size}</td>
                      <td>{item.finish}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* FAQ */}
          {selectedProduct.faq && (
            <div className="faq-section">

              <h2>Frequently Asked Questions</h2>

              {selectedProduct.faq.map((item, index) => (
                <div key={index} className="faq-box">

                  <div
                    className={`faq-question ${activeFAQ === index ? "active" : ""}`}
                    onClick={() =>
                      setActiveFAQ(activeFAQ === index ? null : index)
                    }
                  >
                    <h4>{item.question}</h4>
                    <span>{activeFAQ === index ? "-" : "+"}</span>
                  </div>

                  {activeFAQ === index && (
                    <div className="faq-answer">
                      <p>{item.answer}</p>
                    </div>
                  )}

                </div>
              ))}

            </div>
          )}
{previewImage && (
  <div
    className="image-preview-modal"
    onClick={() => setPreviewImage(null)}
  >
    <span
      className="image-preview-close"
      onClick={() => setPreviewImage(null)}
    >
      ✕
    </span>

    <img
      src={previewImage}
      alt="Preview"
      className="image-preview-full"
      onClick={(e) => e.stopPropagation()}
    />
  </div>
)}
        </>
      )}
    </div>
  );
};

export default PullOut;